import axios from "axios";

const http = axios.create({
	baseURL: process.env.REACT_APP_API_BASEURL,
});

http.interceptors.request.use(
	(config) => {
		const userData = JSON.parse(localStorage.getItem("user"));
		config.headers = {
			Authorization: `Bearer ${userData?.tokens?.accessToken}`,
		};
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

http.interceptors.response.use(
	(response) => response,
	(error) => {
		const requestConfig = error.config;

		if (
			error.response.status === 401 &&
			error.response.data?.error === "jwt expired"
		) {
			const userData = JSON.parse(localStorage.getItem("user"));
			return http({
				method: "POST",
				url: "/user/refresh-tokens",
				data: {
					refreshToken: userData?.tokens.refreshToken,
				},
			})
				.then((res) => {
					const { tokens } = res.data;

					localStorage.setItem("user", JSON.stringify({ tokens }));

					requestConfig.headers.Authorization = `Bearer ${tokens.accessToken}`;

					return http(requestConfig);
				})
				.catch((err) => {
					error.message = "Session has expired.";

					return error;
				});
		}
		return Promise.reject(error);
	}
);

export default http;
